import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import { generateScenarioFileUrl } from '@/utils/generateScenarioFileUrl';
import classNames from 'classnames';
import type React from 'react';
import { Dialog } from '../../Dialog';
import styles from './index.module.scss';

export const COURSE_LESSON_SCENARIO_STORY_DOCUMENT_FRAGMENT =
  graphql(/* GraphQL */ `
  fragment EmbaCourseLessonScenarioStoryDocument on ScenarioContentDocument {
    ...on ScenarioContentDocument {
      dialog
      name
      character
      document
    }
  }
`);

type DocumentProps = {
  currentStoryContent: FragmentType<
    typeof COURSE_LESSON_SCENARIO_STORY_DOCUMENT_FRAGMENT
  >;
  isEnableNext: boolean;
  animationComplete: () => void;
  typingSpeed: number;
  showBlinkingArrow: boolean;
  isModalVisible: boolean;
  setIsModalVisible: (value: boolean) => void;
  slideToNext: () => void;
  embaUserlastName: string;
};

export const Document: React.FC<DocumentProps> = ({
  currentStoryContent,
  isEnableNext,
  animationComplete,
  typingSpeed,
  showBlinkingArrow,
  isModalVisible,
  setIsModalVisible,
  slideToNext,
  embaUserlastName,
}) => {
  const currentStoryContentData = useFragment(
    COURSE_LESSON_SCENARIO_STORY_DOCUMENT_FRAGMENT,
    currentStoryContent,
  );
  return (
    <>
      <div className={styles.contentArea}>
        <div className={styles.documentWrapper}>
          <div className={styles.document}>
            <img
              className={styles.documentImage}
              src={generateScenarioFileUrl(
                currentStoryContentData.document,
                'document',
              )}
              alt=""
              onClick={() => setIsModalVisible(!isModalVisible)}
            />
          </div>
          <div
            className={classNames(styles.modal, {
              [styles.show]: isModalVisible,
            })}
          >
            <img
              src={generateScenarioFileUrl(
                currentStoryContentData.document,
                'document',
              )}
              alt=""
              onClick={() => setIsModalVisible(!isModalVisible)}
            />
          </div>
        </div>
      </div>
      <Dialog
        dialog={currentStoryContentData.dialog}
        name={currentStoryContentData.name}
        character={currentStoryContentData.character}
        embaUserlastName={embaUserlastName}
        isEnableNext={isEnableNext}
        slideToNext={slideToNext}
        animationComplete={animationComplete}
        typingSpeed={typingSpeed}
        showBlinkingArrow={showBlinkingArrow}
      />
    </>
  );
};
